export const PERMISSIONS = {
  MANAGE_GROUPS : "MANAGE_GROUPS",
  MANAGE_USERS : "MANAGE_USERS",
  CMP_ACCESS : "ROLE_BASIC",
  TENANT_CREATE : "TENANT_CREATE",
}

export const SERVICE_IDS = {
  ADMIN: "1",
  CMP : "2",
  SMARTLABEL: "3",
  MENU: "4"
}
